import React from 'react';
import Dish from './Dish';
import formats from '../../utils/formats';
import clsx from 'clsx';

export default function Dishes(props) {
    let { dishes, index, isTastingMenu } = props;

    let classnames = [
        "dishes",
        { "even bg-white": formats.isEven(index) },
        { "odd bg-grey-200": !formats.isEven(index) }
    ];

    return (
        <div className={clsx(classnames)}>
            {0 === dishes.length ?
                (<p>No dishes.</p>) :
                (dishes.map((dish, index) => <Dish dish={dish} key={index} isTastingMenu={isTastingMenu}></Dish>))}
        </div>
    );
}
